import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';

export default function GateTooltip({ text, title }) {
  if (!text) return null;

  const tooltip = <Tooltip id={`gate-text-${title}`}>{text}</Tooltip>;

  return (
    <OverlayTrigger overlay={tooltip} placement="bottom">
      <FontAwesomeIcon className="ml-2" icon={faQuestionCircle} size="lg"/>
    </OverlayTrigger>
  );
}

GateTooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string.isRequired
};
